"use client";
import { DescriptionLink } from "@/components/CTA/variants/MultiCourse/descriptions/DescriptionLink";
import { ClientOnly } from "@/components/Cohesion/ClientOnly";
import useTranslations from "@/i18n/useTranslations";

export default function EarnDescription() {
  const t = useTranslations("MultiCourse");
  let pos = 0;
  return (
    <ClientOnly>
      <div>
        <p>
          <DescriptionLink
            url="/masters"
            position={`${++pos}`}
            variant="masters"
            text="Master’s degrees"
            visibleText={t("mastersDegrees")}
          />
          <b>, </b>
          <DescriptionLink
            url="/doctorate"
            position={`${++pos}`}
            variant="doctorate"
            text="doctorate degrees"
            visibleText={t("doctorateDegrees")}
          />
          <b>{t("earnIntroAnd")}</b>
          <DescriptionLink
            url="/bachelors"
            position={`${++pos}`}
            variant="bachelors"
            text="undergraduate degrees"
            visibleText={t("undergraduateDegrees")}
          />
          &nbsp; {t("earnIntroHelp")}&nbsp;
          <b>{t("flexibleSchedulesAid")}</b>
        </p>
        <ul className="list-disc">
          <li>{t("earnBullet1")}</li>
          <li>{t("earnBullet2")}</li>
          <li>{t("earnBullet3")}</li>
          <li>{t("earnBullet4")}</li>
          <li>{t("earnBullet5")}</li>
        </ul>
      </div>
    </ClientOnly>
  );
}
